import React, {useEffect, useState} from 'react'
import WhiteArrowRight from '../../../media/felsv/white_right-arrow_icon.svg'
import {FormCreacionUsuario} from '../../../interfaces/creacionUsuario.interface'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../reducers'
import {bindActionCreators} from 'redux'
import {
  actionCreacionUsuario,
  actionValidatorsCreacionUsuario,
} from '../../../actions/action-creators'
import { DICCIONARIO } from '../../../constants/Diccionario'
import Help from '../../../components/DesignExterno/Help'

const EmpresaCC = (props: any) => {
  const [disable, setDisable] = useState(true)
  const usuario: FormCreacionUsuario = useSelector((state: State) => state.creacionUsuario.formUser)
  const errors: FormCreacionUsuario = useSelector((state: State) => state.creacionUsuario.formError)
  const dispatch = useDispatch()

  const creacion = bindActionCreators(actionCreacionUsuario, dispatch)
  const validaciones = bindActionCreators(actionValidatorsCreacionUsuario, dispatch)

  useEffect(() => {
    if (usuario.codigo_empresa && !errors.codigo_empresa) setDisable(false)
    else setDisable(true)
  }, [usuario, errors])

  const submit = async (e: any) => {
    e.preventDefault()
    if (await validaciones.validacionesCreacionUsuarioFormEmpresaSiguiente()) return
    if (await creacion.creacionUsuarioVerificarCodigoEmpresa()) props.next()
  }

  
  const handleCodigoEmpresa = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    creacion.creacionUsuarioFormHandleChange(event)
    validaciones.validacionesCreacionUsuarioOnBlurEmpresa(event)
  };


  return (
    <form
      className='form-content'
      data-wf-page-id='64af1c9680a05070de3c97df'
      data-wf-element-id='ac417b8a-12e2-2eb3-27e8-231ec1120128'
      onSubmit={submit}
    >
      <div>
        <label htmlFor='codigo_empresa' className='field-label m' style={{display: 'flex'}}>
          {DICCIONARIO.CODIGO_EMPRESA}
          <span style={{color: 'red'}}>*</span>
          <Help simpleMessage={null} modalTitle='' helpImage={null} id_message='codigo_empresa'/>
        </label>
        <input
          autoComplete='off'
          type='text'
          className='m text-field w-input'
          maxLength={45}
          name='codigo_empresa'
          data-name='codigo_empresa'
          placeholder={DICCIONARIO.CODIGO_EMPRESA}
          id='codigo_empresa'
          autoFocus
          value={usuario.codigo_empresa}
          onChange={handleCodigoEmpresa}
          onBlur={validaciones.validacionesCreacionUsuarioOnBlurEmpresa}
        />
        {errors.codigo_empresa && <p className='alert s'>{errors.codigo_empresa}</p>}
      </div>
      {/* TODO: PENDIENTE DE FUNCIONALIDAD EN FIGMA */}
      {/* <div className='text-note cursor-button'>
        <div>
          <span className='linktext'>¿Cómo puedo conseguir el código?</span>
        </div>
      </div> */}
      <div className='m buttons-div' style={{marginBottom: '5%'}}>
        <button type='submit' className='m button w-inline-block' disabled={disable}>
          Siguiente
          <img src={WhiteArrowRight} loading='lazy' alt='Siguiente' />
        </button>
      </div>
    </form>
  )
}

export default EmpresaCC
